import React from "react";
import { Row } from "react-bootstrap";
import "../candidatesBox/candidatesBox.css";
import Candidateshowmodal from "../Show_candidatemodal";
import Loader from "../../components/Loader";
import { useJobsCandidatesState } from "../../hooks/useJobsCandidatesState";
import {
  CandidateCard,
  CandidateSearchFilter,
  CandidatePagination,
} from "./components";

const JobapplyCandidates = ({ appliedJobdata, isloading, getJobdata }) => {
  const {
    lgShow,
    setLgShow,
    coverletter,
    cvdata,
    location,
    searchText,
    setSearchText,
    selectedJobId,
    setSelectedJobId,
    currentPage,
    totalPages,
    currentItems,
    handlePageChange,
    handleViewCandidate,
  } = useJobsCandidatesState(appliedJobdata);

  // Render Cards
  const renderItems = () => {
    if (currentItems?.length > 0) {
      return currentItems.map((box) => (
        <CandidateCard
          key={box?._id}
          candidate={box}
          onView={handleViewCandidate}
        />
      ));
    }

    return <h4 className="text-center mt-5">No candidates found</h4>;
  };

  return (
    <Row className="px-3">
      <Candidateshowmodal
        lgShow={lgShow}
        setLgShow={setLgShow}
        coverletter={coverletter}
        cvdata={cvdata}
      />

      <div
        className={
          location.pathname === "/RestaurantAlldata" ? "" : `shops-container`
        }
      >
        {/* 🔍 Search Bar & Filter */}
        <CandidateSearchFilter
          searchText={searchText}
          setSearchText={setSearchText}
          selectedJobId={selectedJobId}
          setSelectedJobId={setSelectedJobId}
          getJobdata={getJobdata}
        />

        {isloading ? (
          <Loader heightsetting="scroll-company" />
        ) : (
          <Row className="candidate-height noscroll">
            {renderItems()}

            <CandidatePagination
              totalPages={totalPages}
              currentPage={currentPage}
              onPageChange={handlePageChange}
            />
          </Row>
        )}
      </div>
    </Row>
  );
};

export default JobapplyCandidates;
